const companyEn = {
    company: require('../../lang/en/company/Company').default,
    companyUser: require('../../lang/en/company/CompanyUser').default,
    instituteOnboarding: require('../../lang/en/company/InstituteOnboarding').default,
    branchCourse: require('../../lang/en/company/BranchCourse').default,
}

export default companyEn;

